export interface IOption {
  identifier: string;
  subIdentifier: string;
  subName: string;
  subNameEn: string;
  subNameCn: string;
  subNameKr: string;
  quantity: number;
  minimumOrder: number;
}
export class OptionDTO implements IOption {
  identifier: string;
  subIdentifier: string;
  subName: string;
  subNameEn: string;
  subNameCn: string;
  subNameKr: string;
  quantity: number;
  minimumOrder: number;
}

export default class Option extends OptionDTO {
  constructor(dto?: OptionDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      identifier: "",
      subIdentifier: "",
      subName: "",
      subNameEn: "",
      subNameCn: "",
      subNameKr: "",
      quantity: 0,
      minimumOrder: 0,
    });
  }
}
